import React from 'react'

const SvgMotocycle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M6 22a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5 5a1 1 0 011-1h2.78a2 2 0 011.897 1.368l.176.528.004-.003 1.05-.7A1.15 1.15 0 0117.045 5h.805c.635 0 1.15.515 1.15 1.15v.7A1.15 1.15 0 0117.85 8h-1.796l1.67 6.01a4 4 0 11-1.898.632l-.45-1.351-.016.012c-.528.38-1.129 1.065-1.598 1.932C13.296 16.098 13 17.07 13 18h-2c0-1.231-.519-2.5-1.373-3.46C8.775 13.58 7.657 13 6.5 13H3.499a1.5 1.5 0 110-3h2.265a2 2 0 01.894.211l3.298 1.65 3.762-2.258c.126-.076.248-.137.367-.186L13.279 6H10.5a1 1 0 01-1-1zm7.004 11.673a2 2 0 101.897-.633l.547 1.644a1 1 0 11-1.897.632l-.547-1.643z'
    />
    <path d='M7 18a1 1 0 11-2 0 1 1 0 012 0z' />
  </svg>
)

export default SvgMotocycle
